// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8792) return "main.adec8c5a.css";
	// return url for filenames based on template
	return "" + chunkId + "." + {"2594":"85fba58c","2718":"dc9fe5f8","7147":"2e44e241"}[chunkId] + ".chunk.css";
};